module.exports = __webpack_public_path__ + "media/control_acceso/bolardos-8394b558.png";